// extracted by mini-css-extract-plugin
export default {"title":"ResetCard_title__-rr5D","regex":"ResetCard_regex__OsiQq"};